import { Breadcrumbs } from "@mui/material";
import { styled } from "@mui/material/styles";
import { getBrandCustom } from "../../../../../../util/getCustomColor";

export const GeneralWrapper = styled("div")(() => ({
  padding: "24px 24px 0 24px",
}));

export const HeaderBreadcrumbs = styled(Breadcrumbs)(() => ({
  "& ol": {
    alignItems: "flex-end",
  },
}));

export const HeaderBreadcrumbsTitle = styled("span", {
  shouldForwardProp: (props) => props !== "isActive",
})(({ isActive }: { isActive: boolean }) => ({
  fontSize: 18,
  lineHeight: "24px",
  fontWeight: "bold",
  color: isActive ? "#465869" : getBrandCustom("primaryColor", "#38cfc4"),
  fontFamily: `'Manrope', sans-serif`,
}));
